/**
 * @file 練習ログの添付画像のサムネイルと拡大表示。
 * @what: image_path のサムネイル (タップで全画面の拡大)。image_enc が付いている
 *   (= 暗号化されている) 画像は、この端末では復号できないため文言だけ出す。
 * @why: 読み手が未知の enc を「表示できない」に倒すのが image_enc の規約 (将来の
 *   E2E 暗号化の余地)。取得と URL の寿命は pageImageCache (acquire/release) に乗せ、
 *   一覧に何枚並んでも表示中の URL が revoke されない。
 * @failure: 取得失敗はサムネイル枠に「読めませんでした」。拡大は同じキャッシュを使う
 *   ので追加の取得は起きない。
 */

import { useState } from "react";
import { useScanImage } from "../hooks/useScanImage";
import { PhotoOverlay } from "./PhotoOverlay";
import "./study.css";

export function LogImageThumb({ path, enc }: { path: string; enc?: string | undefined }) {
  const [open, setOpen] = useState(false);
  const image = useScanImage(enc ? null : path, "image/jpeg");

  if (enc) {
    return <span className="study-log-photo-locked">写真（この端末では表示できません）</span>;
  }
  return (
    <>
      <button
        type="button"
        className="study-log-photo-thumb"
        aria-label="写真を拡大する"
        title="タップで拡大"
        onClick={() => setOpen(true)}
      >
        {image.status === "ready" ? (
          <img src={image.url} alt="" loading="lazy" />
        ) : image.status === "error" ? (
          <span className="study-muted">読めませんでした</span>
        ) : null}
      </button>
      {open && image.status === "ready" ? (
        <PhotoOverlay
          src={image.url}
          alt="記録の写真"
          label="写真の拡大表示"
          onClose={() => setOpen(false)}
        />
      ) : null}
    </>
  );
}
